/**
 * Look Book Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/list-collections.liquid
 * 
 */

import Vue from 'vue';
import axios from 'axios';
import filter from 'lodash-es/filter';
import sortBy from 'lodash-es/sortBy';

import {requestConfig} from './../util/storefront';

Vue.component('look-book', {

    props: ['default'],

    data() {
        return {
            isLoading: false,
            allCollections: [],
            currentLookBook: [],
            filterBy: null
        }
    },

    created() {
        this._getCollections();
    },

    methods: {
        filter(_string) {
            // console.log('filter', _string);
            this.filterBy = _string;

            this.currentLookBook = filter(this.allCollections, (_collection) => {
                return _collection.node.title.trim().toLowerCase().indexOf(_string) != -1;
            });

            this.currentLookBook = sortBy(this.currentLookBook, (_collection) => {
                let sortValue = _collection.node.title;
                let split = _collection.node.title.split("|");
                if (split[1]) {
                    let value = parseInt(split[1].trim());
                    if (!isNaN(value)) {
                        sortValue = value;
                    }
                }
                return sortValue;
            });
        },

        _getCollections(lastCursor=null) {
            this.isLoading = true;

            let args = 'first: 250';
            if (lastCursor) {
                args += `, after: "${lastCursor}"`;
            }

            let data = `{
                collections(${args}) {
                    edges {
                        node {
                            id
                            handle
                            title
                            image {
                                transformedSrc(maxWidth: 260, scale: 2)
                            }
                        }
                        cursor
                    }
                    pageInfo {
                        hasNextPage
                    }
                }
            }`;
    
            axios.post('/api/graphql', data, requestConfig).then((response) => {
                // console.log('graphql', response.data);
                this.allCollections = this.allCollections.concat(response.data.data.collections.edges);

                if (response.data.data.collections.pageInfo.hasNextPage) {
                    this._getCollections(response.data.data.collections.edges[response.data.data.collections.edges.length - 1].cursor);

                } else {
                    let hash = window.location.hash;
                    if (hash) {
                        // console.log('hash', hash);
                        let _filterBy = decodeURI(hash.substring(1, hash.length));
                        if (_filterBy) {
                            this.filter(_filterBy);
                        } else {
                            this.filter(this.default);
                        }
                        
                    } else {
                        this.filter(this.default);
                    }

                    this.isLoading = false;
                }
    
            }).catch((error) => {
                console.log(error);
                this.isLoading = false;
            });
        }
    }
});